import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateRole } from '../store/userReducer';
import { useRole } from '../utils/RoleContext';
import { useUser } from '../hooks/useUser';
import { canAccessWebPlatform } from '../permissions';

const Role = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setRole } = useRole();
    const { state } = useLocation();
    const { user } = useUser();
    const roles = state?.roles?.length ? state.roles : user.roles || [];

    const handleSelectRole = (role) => {
        dispatch(updateRole(role.uuid));
        const roleForPermission = role.role || role.name;
        sessionStorage.setItem('role', roleForPermission);
        setRole(roleForPermission);
        if (canAccessWebPlatform(roleForPermission)) {
            navigate('/', { replace: true });
            return;
        }
        navigate('/restricted', { replace: true });
    };

    return (
        <Paper sx={{ p: 4, width: 420 }}>
            <Typography variant="h5" mb={2}>
                Selecionar perfil
            </Typography>
            {roles.length === 0 ? (
                <Typography variant="body2">
                    Nenhum perfil disponível.
                </Typography>
            ) : (
                <Stack spacing={1}>
                    {roles.map((role) => (
                        <Box
                            key={role.uuid}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 1.5,
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1
                            }}
                        >
                            <Box>
                                <Typography variant="subtitle1">
                                    {role.name}
                                </Typography>
                                {role.account?.name && (
                                    <Typography variant="body2" color="text.secondary">
                                        {role.account.name}
                                    </Typography>
                                )}
                            </Box>
                            <Button
                                variant="contained"
                                onClick={() => handleSelectRole(role)}
                            >
                                Selecionar
                            </Button>
                        </Box>
                    ))}
                </Stack>
            )}
        </Paper>
    );
};

export default Role;
